import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { PatientValidators } from '../../../core/validators/patient.validators';

@Component({
  selector: 'app-form-error-message',
  standalone: false,
  templateUrl: './form-error-message.component.html',
  styleUrl: './form-error-message.component.css'
})
export class FormErrorMessageComponent {
  @Input() control: AbstractControl | null = null;
  @Input() fieldName: string = '';

  get hasError(): boolean {
    return PatientValidators.hasError(this.control);
  }

  get errorMessage(): string {
    if (!this.hasError || !this.control) {
      return '';
    }

    // Use provided fieldName or try to get it from the control's parent form
    const displayName = this.fieldName || PatientValidators.getFieldName(this.control?.parent?.get(this.fieldName)?.value || '');
    return PatientValidators.getErrorMessage(this.control, displayName || 'This field');
  }
}
